import SEOHead from '@/components/base/SEOHead';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import FeaturedSection from './components/FeaturedSection';
import CategorySection from './components/CategorySection';
import LatestSection from './components/LatestSection';
import CTASection from './components/CTASection';

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '韩漫免费网站',
  url: 'http://lczydmb.com/',
  description: '韩漫免费网站，汇聚韩国漫画大全并提供无删减内容在线免费观看，高清画质与流畅阅读体验让您随时随地享受精彩故事。',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'http://lczydmb.com/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

const orgSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '韩漫免费网站',
  url: 'http://lczydmb.com/',
  description: '国内领先的韩国漫画在线阅读平台',
  contactPoint: {
    '@type': 'ContactPoint',
    telephone: '400-888-6666',
    contactType: 'customer service',
    email: 'hello@lczydmb.com',
  },
  address: {
    '@type': 'PostalAddress',
    streetAddress: '望京SOHO T1-B座 1808室',
    addressLocality: '北京',
    addressRegion: '朝阳区',
    addressCountry: 'CN',
  },
};

export default function Home() {
  return (
    <>
      <SEOHead
        title="韩漫画免费网站_韩国漫画大全_韩漫无删减在线免费观看-韩漫网站"
        description="欢迎访问韩漫免费网站，这里汇聚韩国漫画大全并提供无删减内容在线免费观看，高清画质与流畅阅读体验让您随时随地享受精彩故事。韩漫免费网站是您的最佳韩漫阅读平台。"
        keywords="韩漫免费网站,韩国漫画大全,韩漫无删减,在线免费观看,韩漫网站"
        canonicalUrl="http://lczydmb.com/"
      />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(orgSchema) }}
      />

      <Navbar />
      <main>
        <HeroSection />
        <FeaturedSection />
        <CategorySection />
        <LatestSection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}